import React, { createContext, useContext } from 'react';
import { useSignalRIdSet } from '../../hooks/realtime/useSignalRIdSet';

export function createLiveStatusContext({ key, startEvent, endEvent }) {
  const Context = createContext(null);

  function Provider({ children }) {
    const { ids, optimisticAdd, optimisticRemove } = useSignalRIdSet(key, startEvent, endEvent);
    return <Context.Provider value={{ ids, optimisticAdd, optimisticRemove }}>{children}</Context.Provider>;
  }
  function useStatus() {
    const ctx = useContext(Context);
    if (ctx === null) throw new Error(`"${key}" live status hooks must be used within its Provider`);
    return ctx;
  }

  function useIds() {
    return useStatus().ids;
  }
  function useIsActive(entityId) {
    return useStatus().ids.has(Number(entityId));
  }
  function useOptimisticAdd() {
    return useStatus().optimisticAdd;
  }
  function useOptimisticRemove() {
    return useStatus().optimisticRemove;
  }

  return { Provider, useIds, useIsActive, useOptimisticAdd, useOptimisticRemove };
}
